import { PsHttpService } from '@patsnap/tahiti-core';
import { resolveApiPath } from '../../utils/api-path-resolver';

/**
 * 支持游客模式的HTTP服务基类
 * 自动根据用户登录状态选择正确的API路径
 */
export abstract class GuestAwareHttpService extends PsHttpService {
    /**
     * 获取基础配置
     * 子类可以重写此方法来提供自定义配置
     */
    get options() {
        const baseURL = import.meta.env.DEV
            ? ''
            : import.meta.env.VITE_TELECOM_API;

        return {
            baseURL,
            timeout: 600000, // 设置 10 分钟超时
            headers: {
                'Content-Type': 'application/json',
            },
        };
    }

    /**
     * 发送POST请求，自动解析API路径
     * @param config 请求配置
     * @param basePath API基础路径（不包含 /telecom/ 前缀）
     */
    protected async postWithGuestSupport<T>(
        config: {
            data?: any;
            headers?: Record<string, string>;
            timeout?: number;
        },
        basePath: string
    ): Promise<T> {
        const resolvedUrl = await resolveApiPath(basePath);

        return this.post<T>({
            url: resolvedUrl,
            data: config.data,
            timeout: config.timeout,
            headers: {
                ...this.getDefaultHeaders(),
                ...config.headers,
            },
        });
    }

    /**
     * 发送GET请求，自动解析API路径
     * @param basePath API基础路径（不包含 /telecom/ 前缀）
     * @param params 查询参数
     * @param headers 请求头
     */
    protected async getWithGuestSupport<T>(
        basePath: string,
        params?: Record<string, any>,
        headers?: Record<string, string>
    ): Promise<T> {
        const resolvedUrl = await resolveApiPath(basePath);

        // 构建查询字符串
        let url = resolvedUrl;
        if (params && Object.keys(params).length > 0) {
            const searchParams = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    searchParams.append(key, String(value));
                }
            });
            url += `?${searchParams.toString()}`;
        }

        return this.get<T>({
            url,
            headers: {
                ...this.getDefaultHeaders(),
                ...headers,
            },
        });
    }

    /**
     * 获取默认请求头
     * 子类可以重写此方法来提供自定义请求头
     */
    protected getDefaultHeaders(): Record<string, string> {
        return {
            'X-PatSnap-From': 's-analytics-telecom',
        };
    }
}